<template>
    <div
        id="menupage"
        class="grid grid-cols-12 items-stretch gap-8 p-4"
    >
        <div
            @click="$router.push('/workpostsmenu')"
            class="menuitem"
        >
            <h2>{{ trans('pages.menu.workstations') }}</h2>
            <div class="menuimgdiv">
                <i class="fa fa-briefcase fa-5x" />
            </div>
        </div>
        <div
            @click="$router.push('/productionprogress')"
            class="menuitem"
        >
            <h2>{{ trans('pages.menu.production_progress') }}</h2>
            <div class="menuimgdiv">
                <i class="fa fa-tasks fa-5x" />
            </div>
        </div>
        <div
            class="menuitem"
            v-if="isAdmin"
        >
            <h2>{{ trans('pages.menu.validation') }}</h2>
            <ui5-button
                @click="$router.push('/validate-cutting-pleating')"
                id="inputcuttingandpleating"
            >
                {{ trans('pages.menu.cutting_and_pleating') }}
            </ui5-button>
            <ui5-button @click="$router.push('/glassproducts')">
                {{ trans('pages.menu.glass_products') }}
            </ui5-button>
            <ui5-button @click="$router.push('/validateproducts')">
                {{ trans('pages.menu.other_iv') }}
            </ui5-button>
        </div>
        <div
            class="menuitem"
            v-if="isAdmin"
        >
            <h2>{{ trans('pages.menu.input') }}</h2>
            <ui5-button @click="$router.push('/neworders')">
                {{ trans('pages.menu.new_orders') }}
            </ui5-button>
            <ui5-button @click="$router.push('/services')">
                {{ trans('pages.menu.services') }}
            </ui5-button>
            <ui5-button @click="$router.push('/quotations')">
                {{ trans('pages.menu.price_requests') }}
            </ui5-button>
        </div>
        <div class="menuitem">
            <h2>{{ trans('pages.menu.to_deliver') }}</h2>
            <ui5-button @click="$router.push('/orderlineoverview')">
                {{ trans('pages.menu.articles') }}
            </ui5-button>
            <ui5-button
                @click="$router.push('/semifinishedproductdeliveroverview')"
            >
                {{ trans('pages.menu.products_and_semi_finished') }}
            </ui5-button>
        </div>
        <div class="menuitem">
            <h2>{{ trans('pages.menu.product_overview') }}</h2>
            <ui5-button @click="$router.push('/productoverview')">
                {{ trans('pages.menu.list') }}
            </ui5-button>
            <ui5-button
                v-if="isAdmin"
                @click="$router.push('/producteditoverview')"
            >
                {{ trans('pages.menu.edit') }}
            </ui5-button>
        </div>
        <div class="menuitem">
            <h2>{{ trans('pages.menu.search') }}</h2>
            <div class="flex items-stretch gap-1">
                <ui5-input
                    class="flex-1 bg-white/40"
                    type="Text"
                    :value="productSearch"
                    @input="productSearch = $event.target.value"
                    @keyup.enter="searchProduct()"
                    :placeholder="trans('pages.menu.product')"
                ></ui5-input>
                <ui5-button @click="searchProduct()">
                    <i class="fa fa-search"></i>
                </ui5-button>
            </div>
            <div class="flex items-stretch gap-1">
                <ui5-input
                    class="flex-1 bg-white/40"
                    type="Text"
                    :value="orderSearch"
                    @input="orderSearch = $event.target.value"
                    @keyup.enter="searchOrder()"
                    :placeholder="trans('pages.menu.order')"
                ></ui5-input>
                <ui5-button @click="searchOrder()">
                    <i class="fa fa-search"></i>
                </ui5-button>
            </div>
            <div class="flex items-stretch gap-1">
                <ui5-input
                    class="flex-1 bg-white/40"
                    type="Text"
                    :value="serviceSearch"
                    @input="serviceSearch = $event.target.value"
                    @keyup.enter="searchService()"
                    :placeholder="trans('pages.menu.service')"
                ></ui5-input>
                <ui5-button @click="searchService()">
                    <i class="fa fa-search"></i>
                </ui5-button>
            </div>
        </div>
        <div
            class="menuitem"
            v-if="isAdmin || isSuperAdmin || isProductionOnly"
        >
            <h2>{{ trans('pages.menu.batch') }}</h2>
            <ui5-button @click="$router.push('/batch')">
                {{ trans('pages.menu.products') }}
            </ui5-button>
        </div>
        <div
            id="pleatingactions"
            class="menuitem"
        >
            <h2>{{ trans('pages.menu.pleating_work') }}</h2>
            <ui5-button @click="$router.push('/pleatingworkoverview')">
                {{ trans('pages.menu.pleating_work_overview') }}
            </ui5-button>
            <ui5-button @click="$router.push('/pleatinglistoverview')">
                {{ trans('pages.menu.pleating_slips') }}
            </ui5-button>
        </div>

        <div
            id="canvas-actions"
            class="menuitem"
        >
            <h2>{{ trans('pages.menu.canvas_slips') }}</h2>
            <ui5-button @click="$router.push('/canvasworkoverview')">
                {{ trans('pages.menu.canvas_overview') }}
            </ui5-button>
            <ui5-button @click="$router.push('/optimizedcanvaslists')">
                {{ trans('pages.menu.canvas_slips') }}
            </ui5-button>
        </div>

        <div
            id="paintactions"
            class="menuitem"
        >
            <h2>{{ trans('pages.menu.paint_work_order') }}</h2>
            <ui5-button @click="$router.push('/createpaintworkform')">
                {{ trans('pages.menu.new') }}
            </ui5-button>
            <ui5-button @click="$router.push('/paintworkform')">
                {{ trans('pages.menu.overview') }}
            </ui5-button>
            <ui5-button @click="$router.push('/paintlistform')">
                {{ trans('pages.menu.paint_slips') }}
            </ui5-button>
            <div class="flex items-stretch gap-1">
                <ui5-input
                    class="flex-1 bg-white/40"
                    type="Text"
                    :value="optimizedPaintListSearch"
                    @input="optimizedPaintListSearch = $event.target.value"
                    @keyup.enter="searchOptimizedPaintList()"
                    :placeholder="trans('pages.menu.optimized_paint_list')"
                ></ui5-input>
                <ui5-button @click="searchOptimizedPaintList()">
                    <i class="fa fa-search"></i>
                </ui5-button>
            </div>
        </div>

        <div
            @click="goToPaintShop()"
            class="menuitem"
        >
            <h2>{{ trans('pages.menu.paint_shop') }}</h2>
            <div class="menuimgdiv">
                <i class="fa fa-paint-brush fa-5x" />
            </div>
        </div>

        <div
            id="tikklokmenu"
            class="menuitem"
        >
            <!-- Generated in initalization.js
            to hide either the listview or the buttons-->
            <h2>{{ trans('pages.menu.time_clock') }}</h2>
            <ui5-button
                v-if="this.hasUserLocation"
                @click="$router.push('/time')"
            >
                {{ trans('pages.menu.details') }}
            </ui5-button>
            <ui5-card
                class="medium"
                v-else
            >
                <ui5-card-header
                    slot="header"
                    :title-text="trans('pages.menu.work_location')"
                />
                <div class="card-content">
                    <ui5-list separators="None">
                        <ui5-li @click="registerTimeLocation('Productie')">
                            {{ trans('pages.menu.production') }}
                        </ui5-li>
                        <ui5-li @click="registerTimeLocation('Verplaatsing')">
                            {{ trans('pages.menu.displacement') }}
                        </ui5-li>
                    </ui5-list>
                </div>
            </ui5-card>
        </div>

        <div
            v-if="isAdmin"
            class="menuitem"
        >
            <h2>{{ trans('pages.menu.data') }}</h2>
            <ui5-button
                id="inputral"
                @click="$router.push('/inputral')"
            >
                {{ trans('pages.menu.colors') }}
            </ui5-button>
            <ui5-button
                id="inputprofile"
                @click="$router.push('/inputprofile')"
            >
                {{ trans('pages.menu.profiles') }}
            </ui5-button>
            <ui5-button
                id="inputworkinghour"
                @click="$router.push('/inputworkhour')"
            >
                {{ trans('pages.menu.work_hours') }}
            </ui5-button>
            <ui5-button
                id="inputstockarticles"
                @click="$router.push('/inputstockarticlesimages')"
            >
                {{ trans('pages.menu.stock_article_images') }}
            </ui5-button>
        </div>
        <div
            @click="$router.push('/stockcount')"
            class="menuitem"
        >
            <h2>{{ trans('pages.menu.articles') }}</h2>
            <div class="menuimgdiv">
                <i class="fa fa-archive fa-5x" />
            </div>
        </div>
        <div
            @click="$router.push('/coloroverview')"
            class="menuitem"
        >
            <h2>{{ trans('pages.menu.colors') }}</h2>
            <div class="menuimgdiv">
                <i class="fa fa-paint-brush fa-5x" />
            </div>
        </div>
        <div
            @click="$router.push('/canvasoverview')"
            class="menuitem"
        >
            <h2>{{ trans('pages.menu.fabrics') }}</h2>
            <div class="menuimgdiv">
                <i class="fas fa-scroll fa-5x" />
            </div>
        </div>
        <div
            @click="$router.push('/sync')"
            class="menuitem"
        >
            <h2>{{ trans('pages.menu.synchronization') }}</h2>
            <div class="menuimgdiv">
                <i class="fa fa-database fa-5x" />
            </div>
        </div>
        <div
            @click="$router.push('/settings')"
            v-if="isAdmin || isProductionManagement || isProductionOnly"
            class="menuitem"
        >
            <h2>{{ trans('pages.menu.settings') }}</h2>
            <div class="menuimgdiv">
                <i class="fa fa-cog fa-5x" />
            </div>
        </div>
        <div
            @click="$router.push('/employees')"
            v-if="isSuperAdmin"
            class="menuitem"
        >
            <h2>{{ trans('pages.menu.employees') }}</h2>
            <div class="menuimgdiv">
                <i class="fa fa-user fa-5x" />
            </div>
        </div>
        <div
            @click="$router.push('/schedule')"
            class="menuitem"
        >
            <h2>{{ trans('pages.menu.planning') }}</h2>
            <div class="menuimgdiv">
                <i class="fa fa-calendar fa-5x" />
            </div>
        </div>
        <div
            id="menuitemdelivery"
            class="menuitem"
        >
            <h2>{{ trans('pages.menu.transport') }}</h2>
            <ui5-button
                id="deliveryDatesbutton"
                @click="$router.push('/deliverydates')"
            >
                {{ trans('pages.menu.rides') }}
            </ui5-button>
            <ui5-button
                v-if="isAdmin"
                @click="$router.push('/deliveryroutes')"
            >
                {{ trans('pages.menu.rounds') }}
            </ui5-button>
        </div>
        <div
            @click="$router.push('/printtextlabel')"
            class="menuitem"
        >
            <h2>{{ trans('pages.menu.print_text_label') }}</h2>
            <div class="menuimgdiv">
                <i class="fa fa-print fa-5x" />
            </div>
        </div>
        <div
            @click="$router.push('/statistics')"
            class="menuitem"
        >
            <h2>{{ trans('pages.menu.statistics') }}</h2>
            <div class="menuimgdiv">
                <i class="fa fa-bar-chart fa-5x" />
            </div>
        </div>
        <div
            v-if="isAdmin || isSuperAdmin || isProductionOnly"
            class="menuitem"
        >
            <h2>{{ trans('pages.menu.to_order') }}</h2>
            <ui5-button @click="$router.push('/powderoverview')">
                {{ trans('pages.menu.powders') }}
            </ui5-button>
            <ui5-button @click="$router.push('/semifinishedproductoverview')">
                {{ trans('pages.menu.semi_finished_products') }}
            </ui5-button>
        </div>
        <div
            @click="
                $router.push(
                    '/dashboard/?employeeId=' +
                        $store.getters['currentUser/getUserId']
                )
            "
            class="menuitem"
        >
            <h2>{{ trans('pages.menu.dashboard') }}</h2>
            <div class="menuimgdiv">
                <i class="fa fa-bar-chart fa-5x" />
            </div>
        </div>
        <div
            @click="$router.push('/debugmenu')"
            v-if="isAdmin"
            style="opacity: 0.7"
            class="menuitem"
        >
            <h2>{{ trans('pages.menu.debug') }}</h2>
            <div class="menuimgdiv">
                <i class="fa fa-bug fa-5x" />
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import orderApi from '../api/order';
import optimizedPaintListApi from '../api/optimizedPaintList';
import productApi from '../api/product';
import Tikklok from '../shared/Tikklok';
import { showErrorMessage } from '../dialogs';
import localization from '../mixins/localization';

export default {
    mixins: [localization],
    data() {
        return {
            productSearch: '',
            orderSearch: '',
            serviceSearch: '',
            optimizedPaintListSearch: '',
        };
    },
    methods: {
        registerTimeLocation: Tikklok.registerTimeLocation,
        searchProduct() {
            productApi
                .validateProductExistence(this.productSearch)
                .then((response) => {
                    const product = response.data.data;
                    sessionStorage.productId = product.productId;
                    if (product.isGroup == 1) {
                        this.$router.push(
                            '/productgrouppage/' + product.productId
                        );
                    } else {
                        this.$router.push('/productpage/' + product.productId);
                    }
                })
                .catch(() => {
                    showErrorMessage(
                        this.trans('pages.menu.product_not_found')
                    );
                    this.productSearch = '';
                });
        },
        searchOrder() {
            orderApi
                .validateOrderExistance(this.orderSearch)
                .then(() => {
                    this.$router.push(
                        '/editproduct/?orderId=' +
                            this.orderSearch +
                            '&productState=show-producttype'
                    );
                })
                .catch(() => {
                    showErrorMessage(this.trans('pages.menu.order_not_found'));
                    this.orderSearch = '';
                });
        },
        searchOptimizedPaintList() {
            optimizedPaintListApi
                .validateExistence(this.optimizedPaintListSearch)
                .then((response) => {
                    if (!response.data.data.paintlistId) {
                        throw new Error('Not found');
                    }

                    this.$router.push(
                        `/optimizedpaintlistview/${response.data.data.paintlistId}`
                    );
                })
                .catch(() => {
                    showErrorMessage(this.trans('pages.menu.order_not_found'));
                    this.orderSearch = '';
                });
        },
        searchService() {
            orderApi
                .validateOrderExistance(this.serviceSearch)
                .then(() => {
                    this.$router.push(
                        '/editproduct/?orderId=' +
                            this.serviceSearch +
                            '&productState=show-producttype'
                    );
                })
                .catch(() => {
                    showErrorMessage(
                        this.trans('pages.menu.service_order_not_found')
                    );
                    this.serviceSearch = '';
                });
        },
        goToPaintShop() {
            this.$router.push('/work-post-paint-screen');
        },
    },
    computed: {
        ...mapGetters({
            hasRight: 'currentUser/hasRight',
            userLocation: 'currentUser/getUserLocation',
        }),
        hasUserLocation() {
            return this.userLocation && this.userLocation.length > 0;
        },
        isAdmin() {
            return this.hasRight('administration');
        },
        isSuperAdmin() {
            return this.hasRight('admin');
        },
        isProductionManagement() {
            return this.hasRight('productionmanagement');
        },
        isProductionOnly() {
            return this.hasRight('production');
        },
    },
};
</script>
